// extracted by mini-css-extract-plugin
export default {"LogoStrip":"styles_LogoStrip__OFrOk"};